<template>
  <div>
    <v-dialog
      v-model="display"
      persistent
      :retain-focus="false"
      max-width="350"
    >
      <v-card class="mx-auto secondary">
        <CardHeader
          title="SKIFT PASSWORD"
          icon="mdi-close"
          @iconClicked="abortChangePassword"
        />
        <v-card-subtitle class="pt-4 pb-2 px-3">
          {{
            this.user && this.user.id && this.user.id != -1 ? "Skift" : "Nyt"
          }}
          password for {{ userName }}
        </v-card-subtitle>
        <div class="px-3">
          <v-form ref="passwordForm" v-model="passwordValid" lazy-validation>
            <PasswordTemplate
              @passwordUpdated="updatedPassword => (password = updatedPassword)"
            />
          </v-form>
        </div>
        <v-card-actions class="pb-3 px-3">
          <v-spacer />
          <v-btn text class="text-left" @click="abortChangePassword()">
            FORTRYD
          </v-btn>
          <v-btn class="text-right" @click="submitChangePassword()">
            GEM
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="displayPasswordResult"
      :color="
        changePasswordResultError
          ? this.$vuetify.theme.themes.light.error
          : this.$vuetify.theme.themes.light.success
      "
    >
      {{ changePasswordResultText }}
    </v-snackbar>
  </div>
</template>

<script>
import PasswordTemplate from "@/components/templates/PasswordTemplate.vue";
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  name: "changePasswordDialog",
  components: {
    CardHeader,
    PasswordTemplate
  },
  props: {
    display: { type: Boolean, required: true },
    user: { type: Object, required: true }
  },
  data() {
    return {
      passwordValid: false,
      password: "",
      displayPasswordResult: false,
      changePasswordResultError: false,
      changePasswordResultText: ""
    };
  },
  computed: {
    userName() {
      return this.user ? this.user.first_name + " " + this.user.last_name : "";
    }
  },
  methods: {
    abortChangePassword() {
      this.disposeDialog();
    },
    async submitChangePassword() {
      this.$refs.passwordForm.validate();
      if (this.passwordValid && this.user && this.password) {
        const { user, password } = this;
        await this.$store
          .dispatch("user/updatePassword", { user, password })
          .then(
            response => {
              (this.displayPasswordResult = true),
                (this.changePasswordResultText = response);
              this.changePasswordResultError = false;
            },
            error => {
              console.error(error);
              (this.displayPasswordResult = true),
                (this.changePasswordResultText = error);
              this.changePasswordResultError = true;
            }
          );
        this.disposeDialog();
      }
    },
    disposeDialog() {
      this.$refs.passwordForm.reset();
      this.$emit("disposeDialog");
    }
  }
};
</script>
